import apiClient from 'services/httpClient'
import { API_ENDPOINTS } from 'shared/constants/apiEndpoints'

export async function apiSignIn(data) {
    return apiClient.post({ url: API_ENDPOINTS.auth.signIn, data })
}

export async function apiSignUp(data) {
    return apiClient.post({ url: API_ENDPOINTS.auth.signUp, data })
}

export async function apiSignOut() {
    // Sign out is handled client-side by clearing the session state.
    return Promise.resolve()
}

export async function apiForgotPassword(data) {
    return apiClient.post({ url: API_ENDPOINTS.auth.forgotPassword, data })
}

export async function apiResetPassword(data) {
    return apiClient.post({ url: API_ENDPOINTS.auth.resetPassword, data })
}

/**
 * Switch the authenticated user's active Legal_Entity context.
 *
 * Implements the client side of Requirements 2.10 / 2.12: the response
 * carries a fresh JWT scoped to the selected entity (with new
 * active_legal_entity_id, active_role_id, employee_id, permission_scope,
 * and organization attributes); the previously issued token is rejected
 * by the server on the next request via the bumped `token_version`.
 */
export async function apiSwitchEntity(data) {
    return apiClient.post({ url: API_ENDPOINTS.auth.switchEntity, data })
}

export async function apiGetCapabilities() {
    return apiClient.get({ url: API_ENDPOINTS.auth.capabilities })
}
